import { NgModule } from '@angular/core';
import { BasicLinechartComponent } from './basic-linechart.component';



@NgModule({
  declarations: [
    BasicLinechartComponent,
  ],
  imports: [
  ],
  exports: [
    BasicLinechartComponent
  ]
})
export class BasicLinechartModule { }
